/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { PlusSquareIcon16Light } from './PlusSquareIcon16Light';
import { PlusSquareIcon16Regular } from './PlusSquareIcon16Regular';
import { PlusSquareIcon16Solid } from './PlusSquareIcon16Solid';
import { PlusSquareIcon20Light } from './PlusSquareIcon20Light';
import { PlusSquareIcon20Regular } from './PlusSquareIcon20Regular';
import { PlusSquareIcon20Solid } from './PlusSquareIcon20Solid';
import { PlusSquareIcon24Regular } from './PlusSquareIcon24Regular';
import { PlusSquareIcon24Solid } from './PlusSquareIcon24Solid';
import { PlusSquareIcon32Regular } from './PlusSquareIcon32Regular';
import { PlusSquareIcon64Regular } from './PlusSquareIcon64Regular';
var sizes = {
    16: {
        light: PlusSquareIcon16Light,
        regular: PlusSquareIcon16Regular,
        solid: PlusSquareIcon16Solid,
    },
    20: {
        light: PlusSquareIcon20Light,
        regular: PlusSquareIcon20Regular,
        solid: PlusSquareIcon20Solid,
    },
    24: {
        regular: PlusSquareIcon24Regular,
        solid: PlusSquareIcon24Solid,
    },
    32: {
        regular: PlusSquareIcon32Regular,
    },
    64: {
        regular: PlusSquareIcon64Regular,
    },
};
export var PlusSquareIcon = forwardRef('PlusSquareIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
